import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, HostBinding, Input, OnDestroy, OnInit } from '@angular/core';

@Component({
  selector: 'app-badge',
  templateUrl: './badge.component.html',
  styleUrls: ['./badge.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BadgeComponent implements OnInit, OnDestroy {
  @HostBinding('class') @Input() color: 'primary' | 'accent' | 'warn' | 'beta' | 'beta-outline' = 'accent';
  @HostBinding('class.absolute') @Input() absolute = false;
  @HostBinding('style.top') @Input() top: string;
  @HostBinding('style.right') @Input() right: string;
  @HostBinding('style.bottom') @Input() bottom: string;
  @HostBinding('style.left') @Input() left: string;

  @Input() small = false;
  @Input() noTextMobile = false;
  @Input() dot = false;
  @Input() dismissId: string;
  @Input() canDismiss = true;
  @Input() trigger: any;
  @Input() triggerEvent = 'click';
  triggerElement: HTMLElement | null;
  constructor(private cd: ChangeDetectorRef) { }


  get isDismissed(): boolean {
    return this.canDismiss && localStorage.getItem(this.dismissId) === 'false';
  }

  dismiss(): void {
    localStorage.setItem(this.dismissId, 'false');
    this.cd.detectChanges();
  }

  ngOnInit(): void {
    this.triggerElement = this.getNativeElement(this.trigger);

    if (this.triggerElement && this.canDismiss) {
      this.triggerElement.addEventListener(this.triggerEvent, this.onEvent);
    }
  }

  ngOnDestroy(): void {
    if (this.triggerElement) {
      this.triggerElement.removeEventListener(this.triggerEvent, this.onEvent);
    }
  }

  onEvent = () => {
    this.dismiss();
    this.cd.detectChanges();
  };


  getNativeElement(trigger: any): HTMLElement | null {
    if (typeof trigger === 'string') {
      return document.querySelector(trigger);
    }

    if (trigger instanceof ElementRef) {
      return trigger.nativeElement;
    }

    if (trigger && trigger._elementRef instanceof ElementRef) {
      return trigger._elementRef.nativeElement;
    }

    if (trigger instanceof HTMLElement) {
      return trigger;
    }

    return null;
  }

}
